import React, { useEffect } from "react";
import { Button, Col, Form, Input, Modal, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import { PRODUCT_STOCK_COUNTRIES } from "../../../../../constants/ProductConstant";
import i18n from "../../../../../translations/i18n";

const EditAddressModal = ({ visible, onClose, onSave, initialAddress }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && initialAddress) {
      form.setFieldsValue({
        street: initialAddress.street || "",
        houseNumber: initialAddress.houseNumber || "",
        houseNumberAddition: initialAddress.houseNumberAddition || "",
        zipCode: initialAddress.zipCode || "",
        city: initialAddress.city || "",
        country: initialAddress.country || "NL",
      });
    }
  }, [visible, initialAddress, form]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      onSave(values);
      form.resetFields();
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={t("edit_address")}
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {t("cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          {t("save")}
        </Button>,
      ]}
      width={600}
      centered
      zIndex={1200}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col xs={24}>
            <Form.Item name="street" label={t("street")} rules={[{ required: true, message: t("form.enter_street") }]}>
              <Input placeholder={t("street")} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={12}>
            <Form.Item
              name="zipCode"
              label={t("zip_code")}
              rules={[{ required: true, message: t("form.enter_zip_code") }]}
            >
              <Input placeholder={t("zip_code")} />
            </Form.Item>
          </Col>
          <Col xs={12} lg={6}>
            <Form.Item
              name="houseNumber"
              label={t("house_number")}
              rules={[{ required: true, message: t("form.enter_house_number") }]}
            >
              <Input placeholder={t("house_number")} />
            </Form.Item>
          </Col>
          <Col xs={12} lg={6}>
            <Form.Item name="houseNumberAddition" label={t("addition")}>
              <Input placeholder={t("addition")} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={12}>
            <Form.Item name="city" label={t("city")} rules={[{ required: true, message: t("form.enter_city") }]}>
              <Input placeholder={t("city")} />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              name="country"
              label={t("country")}
              rules={[{ required: true, message: t("form.enter_country") }]}
            >
              <Select>
                {PRODUCT_STOCK_COUNTRIES.map((country) => (
                  <Select.Option key={country.code} value={country.code}>
                    {i18n.t(country.label)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditAddressModal;
